import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { dashboardColors } from '../constants';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const { surplusColor, comsumptionColor } = dashboardColors;

export const BarChart = ({ wind, biogas, pv, consumed, allData, loading }) => {
  const surplusVal = wind + biogas + pv;
  const options = {
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: true,
        position: 'top',
        reverse: 'true',
        labels: {
          boxWidth: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 14);
            return size;
          },
          color: '#333',
          font: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 22);
            return {
              size: size,
            };
          },
        },
      },
      title: {
        display: false,
      },
      datalabels: {
        // align: 'end',
        anchor: 'end',
        display:
          consumed.toFixed(1) > 0 && surplusVal.toFixed(1) > 0 ? true : false,
        formatter: () => {
          let percentage =
            allData || !loading
              ? `${Math.round((surplusVal / consumed) * 100)}%`
              : '- %';
          return percentage;
        },
        color: [surplusColor],
        borderRadius: 20,
        borderColor: [surplusColor],
        borderWidth: 2,
        padding: 5,
        backgroundColor: '#fff',
        font: function (context) {
          const width = context.chart.width;
          const size = Math.round(width / 18);
          return {
            size: size,
            weight: 'bold',
          };
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: {
        display: false,
        stacked: true,
        grid: {
          display: false,
        },
      },
      yAxes: {
        max: Math.round((consumed + surplusVal) * 1.25),
        display: true,
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  const xVal = ['Wind'];
  const barThinkness = function (context) {
    const width = context.chart.width;
    const size = Math.round(width / 4.5);
    return size;
  };

  const settings = {
    labels: xVal,
    datasets: [
      {
        datalabels: {
          display: false,
        },
        data: [consumed],
        backgroundColor: [comsumptionColor],
        maxBarThickness: barThinkness,
        label: 'Eigenverbrauch',
      },
      {
        data: [surplusVal],
        backgroundColor: [surplusColor],
        maxBarThickness: barThinkness,
        label: 'Überschuss',
      },
    ],
  };
  return (
    <div className='col-sm-6'>
      <h2 className='fs-4 text-center pb-3 m-small'>Autarkie</h2>
      <div className='position-relative bar-chart-style'>
        <Bar options={options} plugins={[ChartDataLabels]} data={settings} />
      </div>
      <h4
        className='  text-center'
        style={{
          fontSize: 'calc(12px + 1.8vw)',
          paddingTop: 'calc(3vh + 0.5vw)',
        }}
      >
        {allData || !loading
          ? `${consumed.toFixed(0) > 0 ? '+' : ''}${consumed.toFixed(0)} kW`
          : '- kW'}
      </h4>
    </div>
  );
};
